import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from "./services/security";
import { HomeComponent } from './modules/home/components/home/home.component'; 
import { TwoFactorSendCodeComponent } from '@modules/account/login/components/twofactor/send-code/send-code.component';
import { TwoFactorVerifyCodeComponent } from '@modules/account/login/components/twofactor/verify-code/verify-code.component';
import { LoginV2Component } from '@modules/account/login/components/loginv2/loginv2.component';
import { NewPasswordComponent } from '@modules/account/login/components/newpassword/newpassword.component';
import { SendTokenResetPasswordComponent } from '@modules/account/login/components/sendtokennewpassword/send-token-possword.component';
import { ConfirmAccountComponent } from '@modules/account/login/components/confirm-account/confirm-account.component';

const appRoutes: Routes = [
  {
    path: '', data: { breadcrumb: 'Accueil' }, canActivate: [AuthGuardService],
    children: [
      { path: '', redirectTo: 'home', pathMatch: "full", data: { breadcrumb: null, breadcrumbVisible: false } },      
      { path: 'ClientApp/dist', redirectTo:'home', pathMatch:"prefix"},
      { path: 'home', component: HomeComponent, data: { breadcrumb: null, breadcrumbVisible: false }, canActivate: [AuthGuardService] },
      { path: 'Clients', data: { breadcrumb: 'Gestion des clients' }, loadChildren: () => import('./modules/clients/clients.module').then(m => m.ClientsModule) },
      { path: 'Subscription', data : { breadcrumb: ' Gestion de souscription' }, loadChildren: () => import('./modules/clientSubscription/subscription.module').then(m =>m.subscriptionModule) },
      { path: 'Configuration', data : { breadcrumb: 'Configuration' }, loadChildren: () => import('./modules/configuration/configuration.module').then(m =>m.ConfigurationModule) },
      { path: 'GestionRoles', data : { breadcrumb: 'Gestion de rôles' }, loadChildren: () => import('./modules/GestionRoles/GestionRoles.module').then(m =>m.GestionRolesModule) },
      { path: 'GestionGroupes', data : { breadcrumb: 'Gestion de groupes de documents' }, loadChildren: () => import('./modules/clientGroupDoc/clientGroupDoc.module').then(m => m.clientGroupDocModule) }
    ]
  },
  { path: 'Home/ClientApp/dist', redirectTo: '', pathMatch: 'full' },
  { path: 'login', component: LoginV2Component },
  { path: 'login/send-code', component: TwoFactorSendCodeComponent },
  { path: "login/verify-code", component:TwoFactorVerifyCodeComponent },
  { path: "account/ResetPassword", component:NewPasswordComponent },
  { path: "lostPassword", component: SendTokenResetPasswordComponent },
  { path:"account/confirmEmail", component:ConfirmAccountComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
